import type { FunctionComponent } from 'react';

import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import { getAssetUrl } from '../../../shared/utils/get-asset-url';
import type { IFooterIcon } from '../../queries/footer.graphql';

import styles from './footer-icon.module.scss';

const style = createStyleHelper(styles, 'footer-icon');

export interface IFooterProps {
    className?: string;
    footerIcons?: IFooterIcon[];
}

export const FooterIcon: FunctionComponent<IFooterProps> = ({ className, footerIcons }) => {
    if (!footerIcons) {
        return null;
    }

    const assetPath = getAssetUrl(footerIcons[0]?.asset);

    return (
        <div className={createClassName([className, style()])}>
            <img key={footerIcons[0]?.id} className={style('icon')} src={assetPath} />
        </div>
    );
};
